/**
 * 현재 화면 경로(origin 제외 — `pathname + search + hash`) — 재인증 후 원래 위치로 복귀시키기
 * 위해 로그인/authorize-redirect URL 의 `return` 쿼리에 실어 보낸다.
 */
export function currentReturnPath(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
